import LoadingScreen from '../components/LoadingScreen';
import { makeLoadable } from '../components/common/LoadableWrapper';
export const BundlePage = makeLoadable({
  loader: () => import( /* webpackChunkName: "bundle-page" */'../pages/BundlePage'),
  LoadingComponent: LoadingScreen
});
export const HubSpotCreditsPageV1 = makeLoadable({
  loader: () => import( /* webpackChunkName: "hubspot-credits-page-v1" */'../pages/HubSpotCreditsPage'),
  LoadingComponent: LoadingScreen
});

// V2 Pages
export const AddOnsPageV2 = makeLoadable({
  loader: () => import( /* webpackChunkName: "add-ons-page-v2" */'../v2/pages/add-ons/AddOnsPage'),
  LoadingComponent: LoadingScreen
});
export const CommerceHubPageV2 = makeLoadable({
  loader: () => import( /* webpackChunkName: "commerce-hub-page-v2" */'../v2/pages/commerce/CommerceHubPage'),
  LoadingComponent: LoadingScreen
});
export const ContentHubPageV2 = makeLoadable({
  loader: () => import( /* webpackChunkName: "content-hub-page-v2" */'../v2/pages/content/ContentHubPage'),
  LoadingComponent: LoadingScreen
});
export const CustomerPlatformPageV2 = makeLoadable({
  loader: () => import( /* webpackChunkName: "customer-platform-page-v2" */'../v2/pages/customer-platform/CustomerPlatformPage'),
  LoadingComponent: LoadingScreen
});
export const DataHubPageV2 = makeLoadable({
  loader: () => import( /* webpackChunkName: "data-hub-page-v2" */'../v2/pages/data/DataHubPage'),
  LoadingComponent: LoadingScreen
});
export const FreeToolsPageV2 = makeLoadable({
  loader: () => import( /* webpackChunkName: "free-tools-page-v2" */'../v2/pages/free/FreeToolsPage'),
  LoadingComponent: LoadingScreen
});
export const MarketingPlusPageV2 = makeLoadable({
  loader: () => import( /* webpackChunkName: "marketing-plus-page-v2" */'../v2/pages/marketing-plus/MarketingPlusPage'),
  LoadingComponent: LoadingScreen
});
export const MarketingHubPageV2 = makeLoadable({
  loader: () => import( /* webpackChunkName: "marketing-hub-page-v2" */'../v2/pages/marketing/MarketingHubPage'),
  LoadingComponent: LoadingScreen
});
export const SalesHubPageV2 = makeLoadable({
  loader: () => import( /* webpackChunkName: "sales-hub-page-v2" */'../v2/pages/sales/SalesHubPage'),
  LoadingComponent: LoadingScreen
});
export const ServiceHubPageV2 = makeLoadable({
  loader: () => import( /* webpackChunkName: "service-hub-page-v2" */'../v2/pages/service/ServiceHubPage'),
  LoadingComponent: LoadingScreen
});
export const SmartCrmPageV2 = makeLoadable({
  loader: () => import( /* webpackChunkName: "smart-crm-page-v2" */'../v2/pages/smart-crm/SmartCrmPage'),
  LoadingComponent: LoadingScreen
});

// Special Pages
export const HubSpotOnCreditsPage = makeLoadable({
  loader: () => import( /* webpackChunkName: "hsoc-page" */'../v2/pages/HubSpotOnCredits'),
  LoadingComponent: LoadingScreen
});
export const InterstitialPage = makeLoadable({
  loader: () => import( /* webpackChunkName: "interstitial-page" */'pricing-pages-ui/components/interstitial/InterstitialPage')
});
const NAV_ITEM_TO_PAGE = {
  suite: CustomerPlatformPageV2,
  crm: FreeToolsPageV2,
  'marketing-plus': MarketingPlusPageV2,
  'smart-crm': SmartCrmPageV2,
  marketing: MarketingHubPageV2,
  sales: SalesHubPageV2,
  service: ServiceHubPageV2,
  content: ContentHubPageV2,
  data: DataHubPageV2,
  commerce: CommerceHubPageV2,
  'add-ons': AddOnsPageV2
};
export const prefetchPage = navItem => {
  const page = NAV_ITEM_TO_PAGE[navItem];
  if (page) {
    void page.preload();
  }
};